import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface SliderControlsProps {
  onPrevious: () => void;
  onNext: () => void;
  iconSize: number;
}

const SliderControls = ({ onPrevious, onNext, iconSize }: SliderControlsProps) => {
  return (
    <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 flex justify-between px-4">
      <button 
        className="bg-white/50 p-2 rounded-full hover:bg-white/70 transition-colors backdrop-blur-sm"
        onClick={onPrevious}
        aria-label="Previous slide"
      >
        <ChevronLeft size={iconSize} />
      </button>
      <button 
        className="bg-white/50 p-2 rounded-full hover:bg-white/70 transition-colors backdrop-blur-sm"
        onClick={onNext}
        aria-label="Next slide"
      >
        <ChevronRight size={iconSize} />
      </button>
    </div>
  );
};

export default SliderControls;